import React, { useState } from "react";
import {
  CardOne,
  CardThree,
  CardTwo,
  Cards,
  Cardsdiv,
  Check,
  Container,
  Header,
  HeaderText,
  IconArea,
  IconFour,
  IconOne,
  IconThree,
  IconTwo,
  IconeExit,
  Mini,
  MiniTitle,
  Text,
  TextArea,
} from "./style";
import "./style.css";
import { useNavigate } from "react-router-dom";
import User from "../../Services/user";

export default function ProgressaoHome() {
  const Navigate = useNavigate();
  return (
    <Container>
      <Header>
        <IconeExit
          onClick={() => {
              User?.perfil() == "secretaria"
                ? Navigate("/secretaria")
                : Navigate("/coordenador");
            }}
        />
      </Header>
      <Cards>
        <Cardsdiv>
          <CardOne
            onClick={() => {
              User?.perfil() == "secretaria"
                ? Navigate("/visualizarprogre")
                : Navigate("/visualizarprogre/coordenador");
            }}
          >
            <Check>
              <input className="CheckOne" type={"checkbox"} />
            </Check>
            <IconArea>
              <IconOne />
            </IconArea>
            <MiniTitle>
              <Mini>Alunos em progressão</Mini>
            </MiniTitle>
            <TextArea>
              <Text>
                {User?.perfil() == "secretaria"
                  ? "Visualização de todos os alunos em progressão parcial."
                  : "Visualização dos alunos em progressão parcial nos cursos sob sua coordenação."}
              </Text>
            </TextArea>
          </CardOne>
          <CardOne
            onClick={() => {
              User?.perfil() == "secretaria"
                ? Navigate("/progressao-parcial-secretaria")
                : Navigate("/progressao-parcial-coordenador");
            }}
          >
            <Check>
              <input className="CheckThree" type={"checkbox"} />
            </Check>
            <IconArea>
              <IconFour />
            </IconArea>
            <MiniTitle>
              <Mini>Lançamentos</Mini>
            </MiniTitle>
            <TextArea>
              <Text>
                {User?.perfil() == "secretaria"
                  ? "Progressões lançadas pelos professores."
                  : "Progressões lançadas pelos professores nos cursos sob sua coordenação."}
              </Text>
            </TextArea>
          </CardOne>
          {/* 
            <CardTwo onClick={() => setShowRelatorio2(true)}>
              <Check>
                <input className="CheckTwo" type={"checkbox"} />
              </Check>
              <IconArea>
                <IconTwo />
              </IconArea>
              <MiniTitle>
                <Mini>Realização</Mini>
              </MiniTitle>
              <TextArea>
                <Text>Desempenho das progressões realizadas por cada aluno. </Text>
              </TextArea>
            </CardTwo> */}
          {/*
          <CardThree onClick={() => setShowPhoto(true)}>
            <Check>
              <input className="CheckThree" type={"checkbox"} />
            </Check>
            <IconArea>
              <IconThree />
            </IconArea>
            <MiniTitle>
              <Mini>Importação de Fotos</Mini>
            </MiniTitle>
            <TextArea>
              <Text>Carregar as fotos dos alunos.</Text>
            </TextArea>
          </CardThree> */}
        </Cardsdiv>
      </Cards>
    </Container>
  );
}
